import * as z from "zod/v4";

export const updateWorkOrderViewFolder = {
  name: "updateWorkOrderViewFolder" as const,
  input: z.object({ folderId: z.string(), name: z.string() }),
  output: z.object({}),
};
